import { useAtom } from "jotai";
import { useEffect, useState } from "react";

import {
  videoAdFinishedAtom,
  videoAdsGrantedEntriesCounterAtom,
} from "./video-ads-quiz.state";

export function useVideoAdsState() {
  const [, setVideoAdFinished] = useAtom(videoAdFinishedAtom);
  const [entriesCounter, setEntriesCounter] = useAtom(
    videoAdsGrantedEntriesCounterAtom
  );

  const [rewardedSlot, setRewardedSlot] = useState<googletag.Slot | null>(null);

  const videoUnitAdPath = window.FKL.videoUnitAdPath;
  const googletag = window.googletag || { cmd: [] };

  const initGoogleAdsService = (rewardedSlot: googletag.Slot) => {
    rewardedSlot.addService(googletag.pubads());
    googletag.enableServices();
    googletag.display(rewardedSlot);
  };

  const defineVideoAdSlot = () => {
    googletag.cmd.push(() => {
      setRewardedSlot(
        googletag.defineOutOfPageSlot(
          videoUnitAdPath,
          googletag.enums.OutOfPageFormat.REWARDED
        )
      );
    });
  };

  const displayVideoAd = (event: googletag.events.RewardedSlotReadyEvent) => {
    event.makeRewardedVisible();
  };

  const dismissRewardedAd = () => {
    if (rewardedSlot) {
      googletag.pubads().refresh();
      googletag.destroySlots([rewardedSlot]);
      setRewardedSlot(null);
    }
  };

  const grantReward = () => {
    dismissRewardedAd();
    setEntriesCounter(entriesCounter + 1);
    setVideoAdFinished(true);
  };

  useEffect(() => {
    if (rewardedSlot) {
      initGoogleAdsService(rewardedSlot);
    }
  });

  useEffect(() => {
    googletag.pubads().addEventListener("rewardedSlotReady", displayVideoAd);

    return () =>
      googletag
        .pubads()
        .removeEventListener("rewardedSlotReady", displayVideoAd);
  });

  useEffect(() => {
    googletag
      .pubads()
      .addEventListener("rewardedSlotClosed", dismissRewardedAd);

    return () =>
      googletag
        .pubads()
        .removeEventListener("rewardedSlotClosed", dismissRewardedAd);
  });

  useEffect(() => {
    googletag.pubads().addEventListener("rewardedSlotGranted", grantReward);

    return () =>
      googletag
        .pubads()
        .removeEventListener("rewardedSlotGranted", grantReward);
  });

  return { defineVideoAdSlot, videoUnitAdPath };
}
